import { inject, Injectable, linkedSignal, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

export interface CardData {
  cardId: string;
  readTime: Date;
}

@Injectable({
  providedIn: 'root',
})
export class CardDecoderService {
  private httpClient = inject(HttpClient);
  private apiUrl = 'https://localhost/ajax/card';

  private _intervalId: number;
  private checkCardReaderInSec = 1;
  private cardDataFromUnit = signal<CardData | null>(null);

  private _loadedCardData = linkedSignal<CardData, CardData>({
    source: () => this.cardDataFromUnit(),
    computation: (current, previous) => {
      if (!current) {
        return null;
      }
      if (!previous) {
        return current;
      }

      return previous.source.cardId !== current.cardId ? current : previous.value;
    },
  });

  public readonly loadedCardData = this._loadedCardData.asReadonly();

  startListenToCardDecoder() {
    this._intervalId = setInterval((x) => {
      this.tryDecodeCard().subscribe((x) => {
        this.cardDataFromUnit.set(x);
      });
    }, this.checkCardReaderInSec * 1000);
  }

  stopListenToCardDecoder() {
    if (this._intervalId) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }

  private tryDecodeCard(): Observable<CardData> {
    return this.httpClient.post(this.apiUrl, {}).pipe(
      map((x: any) => {
        if (x) {
          return {
            ...x,
            readTime: new Date(x.readTime),
          };
        }
      })
    );
  }
}
